import { useEffect, useState } from 'react'

export function useNow(intervalMs: number | null): Date {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    if (!intervalMs) return
    setNow(new Date())
    const timer = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(timer)
  }, [intervalMs])

  return now
}
